<template>
<v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title class="grey lighten-4">
                    <v-tooltip top>
                         <v-btn
                            slot="activator"
                            dark
                            @click.stop="helpdialog = true"
                            icon class="mx-0">
                        <v-icon color="red">help</v-icon>
                        </v-btn>
                        <span>Entrega Papeles/App</span>
                    </v-tooltip>
                    <h3 class="headline mb-0">Administración de Entrega Papeles</h3>

                    <v-spacer></v-spacer>
                        <v-text-field
                            @change="onChange"
                            slot="input"
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-switch
                        color="primary"
                        v-model="entregados"
                        :label="entregados ? 'Ver Papeles por Entregar' : 'Ver Papeles Entregados'"
                    ></v-switch>
                </v-card-title>
                <div>

                  <v-data-table
                    :headers="headers"
                    :items="papeles"
                    :pagination.sync="pagination"
                    :total-items="total"
                    :rows-per-page-items="rowsPerPageItems"
                    :loading="loading"
                    row
                    wrap
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.cpc }}</td>
                      <td>{{ props.item.cantidad }}</td>
                      <td>{{ props.item.invoice_id }}</td>
                      <td class="text-xs-left">{{ props.item.status }}</td>
                      <td class="justify-center layout px-0">
                        <v-tooltip top v-if="!entregados">
                            <v-btn slot="activator" icon class="mx-0" @click="changeValueEntrega(props)">
                            <v-icon color="info">description</v-icon>
                            </v-btn>
                            <span>Entregar Papel</span>
                        </v-tooltip>
                        <v-tooltip top v-if="props.item.invoice.service_payments[0].delivery_id != null && !entregados">
                            <v-btn slot="activator" icon class="mx-0" @click="asignarDelivery(props)">
                            <v-icon color="info">local_shipping</v-icon>
                            </v-btn>
                            <span>Asignar Delivery</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <v-btn @click="visulizarPapeles(props)" slot="activator" icon class="mx-0" >
                                <v-icon color="primary">description</v-icon>
                            </v-btn>
                            <span>Papeles a Entregar</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </div>

            </v-card>
        </v-flex>


  <!-- Inicio de dialogo -->
    <v-dialog
          v-model="helpdialog"
          max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Roles</v-card-title>

            <v-card-text>
              Mantenimiento de la tabla de Roles del sistema para gestionar el acceso a las funcionalidades del mismo.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="helpdialog = false"
              >
                Salir
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

     <v-dialog v-model="dialogAsignarCourier" width="400" persistent>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0"><span style="color: #9C1A1A">Asignar Courier</span></h3>
                </v-card-title>
                <v-card-text>
                    <v-flex xs12>
                        <v-select
                            prepend-icon="local_shipping"
                            :items="couriers"
                            v-model="formDelivery.couriers"
                            item-text="name"
                            item-value="id"
                            label="Nombre"
                            :rules="[v => !!v || 'Courrier es requerido']"
                            required
                        ></v-select>
                    </v-flex>
                    <v-flex xs12>
                            <v-textarea
                                disabled
                                ref="address"
                                prepend-icon="domain"
                                v-model="formDelivery.address"
                                auto-grow
                                box
                                color="primary"
                                label="Dirección"
                                rows="1"
                            ></v-textarea>
                        </v-flex>
                    <v-flex xs12>
                            <v-textarea
                                disabled
                                ref="guide_mark"
                                prepend-icon="domain"
                                v-model="formDelivery.guide_mark"
                                auto-grow
                                box
                                color="primary"
                                label="Punto de Referencia"
                                rows="1"
                            ></v-textarea>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                disabled
                                ref="local_phone"
                                v-model="formDelivery.local_phone"
                                prepend-icon="phone"
                                label="Tlf Local"
                                mask="phone"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                disabled
                                ref="celular_phone"
                                v-model="formDelivery.celular_phone"
                                prepend-icon="phone"
                                label="Tlf Célular"
                                mask="phone"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                disabled
                                ref="responsable"
                                v-model="formDelivery.responsable"
                                prepend-icon="person"
                                label="Responsable"
                            ></v-text-field>
                        </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary darken-1" @click="cerrarDeliveryCourier">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" @click="sendDelivery">Enviar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogVisualizarPapers" width="600" persistent>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0"><span style="color: #9C1A1A">Papeles Solicitados</span></h3>
                </v-card-title>
                <v-card-text>
                    <p>Cantidad de papeles: {{ cantidadP }} </p>
                <v-list two-line>
                    <template v-for="item in papersP">
                        <v-list-tile :key="item.id" >
                            <v-list-tile-content>
                                <v-list-tile-title v-html="'LOTE: ' + item.security_paper.lote + ' | MI' + item.security_paper.papel"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="item.usado ? 'USADO' : 'NO USADO'"></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary darken-1" @click="dialogVisualizarPapers = false">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import Form from 'vform'
import axios from 'axios'

  export default {
    name: "admin-papeles-entrega-view",

    data: () => ({
        entregados: false,
        cantidadP: 0,
        papersP: [],
        dialog: false,
        dialogVisualizarPapers: false,
        dialogAsignarCourier: false,
        helpdialog: false,
        loading: false,
        total: 0,
        tipo: '',
        search: '',
        pagination: {},
        couriers: [],
        dialogPermissionRole: false,
        headers: [
            { text: 'CPC', align: 'left', sortable: false, value: 'cpc' },
            { text: 'CANTIDAD', align: 'left', sortable: false, value: 'cantidad' },
            { text: 'FACTURA', align: 'left', sortable: false, value: 'invoice_id' },
            { text: 'ESTATUS', align: 'left', sortable: false, value: 'status' },
            { text: 'Acciones', align: 'center', value: '', sortable: false }
        ],
        rowsPerPageItems: [10, 20, 50, 100],
        papeles: [],
        editedIndex: -1,
        editedItem: {
            name: '',
            description: ''
        },
        defaultItem: {
            name: '',
            description: ''
        },
        formDelivery: new Form({
            security_paper_unionizes: '',
            couriers: '',
            address: '',
            local_phone: '',
            celular_phone: '',
            responsable: '',
            guide_mark: '',
        })

    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
      entregados (val) {
        this.getEntregaPaperByPagination();
      },
      pagination() {
        this.getEntregaPaperByPagination();
      }
    },

    mounted() {
        this.getDeliveryCouriers()
    },

    methods: {

        visulizarPapeles(props) {
            this.cantidadP = props.item.cantidad
            this.papersP = props.item.security_paper_unionize
            this.dialogVisualizarPapers = true
        },

        close () {
            this.dialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            }, 300)
        },

        async getDeliveryCouriers() {
            await axios.get(`/api/atencion/get-delivery-courier`)
                        .then(res => {
                            this.couriers = res.data;
                        })
        },

        async asignarDelivery(props) {
            this.formDelivery.security_paper_unionizes = props.item.security_paper_unionize
            this.formDelivery.couriers = props.item.invoice.service_payments[0].delivery.delivery_courier_id
            this.formDelivery.address = props.item.invoice.service_payments[0].delivery.address
            this.formDelivery.local_phone = props.item.invoice.service_payments[0].delivery.local_phone
            this.formDelivery.celular_phone = props.item.invoice.service_payments[0].delivery.celular_phone
            this.formDelivery.responsable = props.item.invoice.service_payments[0].delivery.responsable
            this.formDelivery.guide_mark = props.item.invoice.service_payments[0].delivery.guide_mark
            this.dialogAsignarCourier = true
        },

        async cerrarDeliveryCourier () {
            this.dialogAsignarCourier = false
            this.form = new Form({
                security_paper_unionizes: '',
                couriers: '',
                address: '',
                local_phone: '',
                celular_phone: '',
                responsable: '',
            })
        },

        async sendDelivery() {
            this.loading = true
            await axios.post(`/api/atencion/send-delivery-courier`, this.formDelivery)
                .then(() => {
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: `Delivery activo`
                    })
                    this.dialogAsignarCourier = false
                }).catch(e => {
                    console.log(e.response)
                        // if (e.response.data.errors) {
                        //     if (e.response.data.errors.no_asignado_delivery) {
                        //         this.$store.dispatch('responseMessage', {
                        //             type: 'error',
                        //             text: e.response.data.errors.no_asignado_delivery
                        //         })
                        //     }else {
                        //         this.$store.dispatch('responseMessage', {
                        //             type: 'error',
                        //             text: e.response.data.error
                        //         })
                        //     }
                        // }
                })
                .finally(() => this.loading = false);
        },

        async changeValueEntrega(props) {
            let confirmEntrega =  confirm(`esta seguro de realizar la entrega?`)
            if(confirmEntrega){
                this.loading = true
                await axios.post(`/api/atencion/entrega-papel-seguridad`,{ id: props.item.invoice_id ,stauts: props.item.status })
                    .then(() => {
                        let papel = this.papeles.filter(p => p.invoice_id == props.item.invoice_id);
                        papel.forEach(element => {
                            let index = this.papeles.indexOf(element)
                            this.papeles.splice(index, 1);
                        });
                        // console.log(papel)
                        // this.papeles.splice(papelIndex, 1);
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: `Entrega de papel exitosa`
                        })
                    }).catch(e => {
                        console.log(e.response)
                        if (e.response.data.errors) {
                            if (e.response.data.errors.no_asignado_delivery) {
                                this.$store.dispatch('responseMessage', {
                                    type: 'error',
                                    text: e.response.data.errors.no_asignado_delivery
                                })
                            }else {
                                this.$store.dispatch('responseMessage', {
                                    type: 'error',
                                    text: e.response.data.error
                                })
                            }
                        }
                    }).finally(() => this.loading = false);
            }
        },

        async getEntregaPaperByPagination() {
                this.loading = true;
                if (this.search) {
                    await axios.get(`/api/atencion/entrega-papel-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}&entregados=${this.entregados}`)
                        .then(res => {
                            this.papeles = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
                if (this.pagination.sortBy && !this.search) {
                    const direction = this.pagination.descending ? 'desc' : 'asc';
                    await axios.get(`/api/atencion/entrega-papel-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}&entregados=${this.entregados}`)
                        .then(res => {
                            this.papeles = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
                if(!this.search && !this.pagination.sortBy) {
                    await axios.get(`/api/atencion/entrega-papel?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}&entregados=${this.entregados}`)
                        .then(res => {
                            console.log(res.data)
                            this.papeles = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
        },

        onChange () {
            this.getEntregaPaperByPagination();
        }

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/atencion/entregaPapeles.vue